import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let serviceRequestsApiPromise: Promise<AxiosInstance> | null = null;

const getServiceRequestsApi = async (): Promise<AxiosInstance | null> => {
  const cached = serviceRequestsApiPromise;
  if (cached !== null) return cached;
  serviceRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return serviceRequestsApiPromise;
};

export interface CatalogoServicioItem {
  id: number;
  nombre: string;
  valorUnitario: number;
  unidadCotizacion: number;
}

export interface GetCatalogoServicioProps {
  Categoria?: number;
  UnidadCotizacion?: number;
}

export const getCatalogoServicio = async (
  props: GetCatalogoServicioProps = {},
): Promise<CatalogoServicioItem[] | null> => {
  const api = await getServiceRequestsApi();
  if (!api) return null;

  const queryString = objectToQueryStringWithArray(props);
  const url = queryString ? `/CatalogoServicio?${queryString}` : "/CatalogoServicio";
  const response = await api.get(url);
  return response.data;
};

export interface SolicitudServicioDetail {
  id: number;
  cuentaOrigen: number;
  nombreUsuario: string;
  sucursal: string;
  procedencia: string;
  hectareas: number;
  cantidadMuestras: number;
  valorUnitario: number;
  valorTotal: number;
  fechaDeseada: string;
  tipoServicio: string;
  estado: string;
  detalle: string;
  motivoRechazo?: string;
  usuarioRechazo?: string;
  fechaRechazo?: string;
  unidadCotizacion?: number;

  cantidadMuestrasEjecutadas?: number;
  hectareasEjecutadas?: number;
  fechaRealizacion?: string;
}

export const getSolicitudServicioDetail = async (
  id: number,
): Promise<SolicitudServicioDetail | null> => {
  const api = await getServiceRequestsApi();
  if (!api) return null;
  const response = await api.get(`/SolicitudesServicio/${id}`);
  return response.data;
};

export interface UpdateSolicitudServicioProps {
  id: number;
  idEstado: number;
  motivoRechazo?: string;
  fechaRealizacion?: string;
  cantidadMuestrasEjecutadas?: number;
  hectareasEjecutadas?: number;
}

export const updateSolicitudServicio = async (
  props: UpdateSolicitudServicioProps,
) => {
  const api = await getServiceRequestsApi();
  if (!api) return null;

  const response = await api.patch("/SolicitudesServicio", props);
  return response.data;
};

export interface CreateSolicitudServicioBody {
  cuentaOrigen: number;
  usuarioMobile?: number;
  tipoServicio: number;
  idProcedencia: string;
  fechaDeseada: string;
  hectareas: number;
  cantidadMuestras: number;
  valorTotal: number;
  observaciones: string;
  tipoSolicitud: number;
}

export const createSolicitudServicio = async (body: CreateSolicitudServicioBody) => {
  const api = await getServiceRequestsApi();
  if (!api) return null;

  const response = await api.post("/SolicitudesServicio", body);
  return response.data;
};

export interface GetSolicitudesServicioProps {
  CuentaOrigen?: number;
  TipoSolicitud?: number;
  TipoServicio?: number;
  Estados?: number[];
  FechaDesde?: string;
  FechaHasta?: string;
  "P.Pagina"?: number;
  "P.Records"?: number;
}

export interface SolicitudServicioListItem {
  id: number;
  fecha: string;
  tipoServicio: string;
  categoria: number;
  procedencia: string;
  hectareas: number;
  cantMuestras: number;
  estado: string;
  titularCuenta: string;
  unidadCotizacion: number;
}

export interface SolicitudesServicioListResponse {
  listado: SolicitudServicioListItem[];
  totalPages: number;
  totalRecords: number;
}

export const getSolicitudesServicio = async (
  props: GetSolicitudesServicioProps = {},
): Promise<SolicitudesServicioListResponse | null> => {
  const api = await getServiceRequestsApi();
  if (!api) return null;

  const queryString = objectToQueryStringWithArray(props);
  const url = queryString
    ? `/SolicitudesServicio?${queryString}`
    : "/SolicitudesServicio";
  const response = await api.get(url);
  return response.data;
};
